import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

function AuthGuard(props) {
  const account = useSelector(state => state.account);

  if (!account.currentUser) {
    return <Redirect to="/login"></Redirect>;
  }

  return props.children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
